import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ProductSection from './components/ProductSection';
import ProductGrid from './components/ProductGrid';
import Footer from './components/Footer';
import LanguageSelector from './components/LanguageSelector';
import WhatsAppButton from './components/WhatsAppButton';
import {
  latasMentolados,
  latasSabores,
  saches16g,
  saches18g,
  saches20g,
  saches100g,
  granelMentolados,
  granelSabores
} from './data/mock';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />

      {/* Our Products Intro */}
      <ProductSection 
        title="Our products"
        subtitle="Sweet Life diet tin 32g, display with 10 units 320g or display with 6 units 192g."
      />

      {/* Sweet Life Diet Tins */}
      <ProductSection 
        title="Sweet Life Diet Tins"
        bgColor="bg-gray-50"
      >
        <div className="space-y-12">
          {/* Mint Flavors */}
          <div>
            <h3 className="text-2xl font-bold text-[#3b7ba8] mb-8 text-center">
              MINT FLAVORS
            </h3>
            <ProductGrid products={latasMentolados} columns={5} />
          </div>

          {/* Flavors */}
          <div>
            <h3 className="text-2xl font-bold text-[#3b7ba8] mb-8 text-center">
              FLAVORS
            </h3>
            <ProductGrid products={latasSabores} columns={6} />
          </div>
        </div>
      </ProductSection>

      {/* Sweet Life Diet Sachets 16g */}
      <ProductSection 
        title="Sweet Life Diet Sachets 16g"
      >
        <ProductGrid products={saches16g} columns={6} />
      </ProductSection>

      {/* Bala Abelhinha Sachets 18g */}
      <ProductSection 
        title="Bala Abelhinha Sachets 18g"
        bgColor="bg-gray-50"
      >
        <ProductGrid products={saches18g} columns={3} />
      </ProductSection>

      {/* Sweet Life Diet Sachets 20g */}
      <ProductSection 
        title="Sweet Life Diet Sachets 20g"
      >
        <ProductGrid products={saches20g} columns={5} />
      </ProductSection>

      {/* Sweet Life Diet Sachets 100g */}
      <ProductSection 
        title="Sweet Life Diet Sachets 100g"
        bgColor="bg-gray-50"
      >
        <ProductGrid products={saches100g} columns={5} />
      </ProductSection>

      {/* Sweet Life Diet Bulk */}
      <ProductSection 
        title="SWEET LIFE DIET BULK - STAND UP POUCH PACKAGING 500g AND 1kg."
      >
        <div className="flex flex-col lg:flex-row gap-12 items-start">
          {/* Image */}
          <div className="flex-1 flex justify-center">
            <img 
              src="https://www.sweetlife.com.br/images/balas/a-granel.png" 
              alt="Bulk candies"
              className="w-full max-w-md h-auto"
            />
          </div>
          
          {/* Flavor Lists */}
          <div className="flex-1 space-y-8">
            <div>
              <h3 className="text-2xl font-bold text-[#3b7ba8] mb-4">
                MINT FLAVORS
              </h3>
              <ul className="space-y-2 text-gray-700">
                {granelMentolados.map((sabor, index) => (
                  <li key={index} className="text-lg">• {sabor}</li>
                ))}
              </ul>
            </div>
            
            <div>
              <h3 className="text-2xl font-bold text-[#3b7ba8] mb-4">
                FLAVORS
              </h3>
              <ul className="space-y-2 text-gray-700">
                {granelSabores.map((sabor, index) => (
                  <li key={index} className="text-lg">• {sabor}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </ProductSection>

      {/* Premium Candies */}
      <ProductSection bgColor="bg-gray-50">
        <div className="flex flex-col lg:flex-row gap-12 items-center">
          <div className="flex-1 flex justify-center">
            <img 
              src="https://www.sweetlife.com.br/images/balas/balas-premium.png" 
              alt="Premium Candies"
              className="w-full max-w-md h-auto"
            />
          </div>
          <div className="flex-1 space-y-4">
            <h2 className="text-3xl md:text-4xl font-bold text-[#3b7ba8]">
              Premium Sweet Coffee Candies Sugar Free.
            </h2>
            <p className="text-lg text-gray-700">
              Made with soluble coffee, natural sweetener and no preservatives. Available in a display with 6 units of 32g, total of 192g.
            </p>
          </div>
        </div>
      </ProductSection>

      <Footer />
      <LanguageSelector />
      <WhatsAppButton />
    </div>
  );
}

export default App;
